import { Injectable } from '@angular/core';
import { Http, Response, URLSearchParams } from '@angular/http';
import { BaseService } from '../shared/service/base.service';
import { AuthService } from '../shared/auth/auth.service';
import { Module } from '../shared/model/module.model';
import { Observable } from 'rxjs';
import { Brand } from '../brands-list/brands.model';
import { CategoryListModel } from '../category-list/category-list.model';
import { UserQuota } from '../shared/model/userquota.model';
import {EnrolResponse} from '../shared/model/enrolresponse.model';
@Injectable()
export class EnrolToModuleService extends BaseService<Module> {

  constructor(_authService: AuthService,
    _http: Http) {
    super('/api/modules', _authService, _http);
  }

  getHomeModules(view: string,brandId?:string,categoryId?:string): Observable<Module[]> {
    let params: URLSearchParams = new URLSearchParams();

    if (view !== undefined) {
      params.set('view', view);
    } else {
      params.set('view', 'Featured');
    }
     if (brandId !== undefined) {
      params.set('brandId', brandId);
    } else {
      params.set('brandId', '');
    }
     if (categoryId !== undefined) {
      params.set('categoryId', categoryId);
    } else {
      params.set('categoryId', '');
    }
    if(this._authService.getUserData() != null){
    console.log(this._authService.getUserData().breezeSessionString);
    if(this._authService.getUserData().breezeSessionString !== undefined){
      params.set('breezeSessionString',this._authService.getUserData().breezeSessionString);
    }else{
      params.set('breezeSessionString',this._authService.getBreezeSessionString());
    }
     console.log(this._authService.getUserData().iBreezeUserID);
     if(this._authService.getUserData().iBreezeUserID !== undefined){
      params.set('iBreezeUserID',this._authService.getUserData().iBreezeUserID);
    }else{
      params.set('iBreezeUserID','');
    }
  }
    return this._http.get(this._baseUrl + '/getHomeFeaturedModules', {
      headers: this._authService.getAuthorizationHeaders(),
      search: params
    })
      .map((res: Response) => res.json())
      ;
  }

  getBrandsList():Observable<Brand[]> {
      let params: URLSearchParams = new URLSearchParams();
    return this._http.get(this._baseUrl + '/getAllBrands', {
      headers: this._authService.getAuthorizationHeaders(),
      search: params
    })
      .map((res: Response) => res.json())
      ;
  }

  getCategoryList():Observable<CategoryListModel[]> {
      let params: URLSearchParams = new URLSearchParams();
    return this._http.get(this._baseUrl + '/getAllCategories', {
      headers: this._authService.getAuthorizationHeaders(),
      search: params
    })
      .map((res: Response) => res.json())
      ;
  }

   getModuleByModuleId(view: string,iModuleID?:string): Observable<Module> {
      let params: URLSearchParams = new URLSearchParams();
      if (view !== undefined) {
      params.set('view', view);
    } else {
      params.set('view', 'Featured');
    }
     if (iModuleID !== undefined) {
      params.set('iModuleID', iModuleID);
    } else {
      params.set('iModuleID', '');
    }
    return this._http.get(this._baseUrl + '/getModuleByModuleId', {
      headers: this._authService.getAuthorizationHeaders(),
      search: params
    })
      .map((res: Response) => res.json())
      ;
   }

   checkQuotaReached():Observable<UserQuota>{
      let params: URLSearchParams = new URLSearchParams();
       return this._http.get('/api/breezeAuthentication/getQuota', {
      headers: this._authService.getAuthorizationHeaders(),
      search: params
    })
      .map((res: Response) => res.json())
      ;
   }

   isUserSessionAlive():Observable<UserQuota>{

      let params: URLSearchParams = new URLSearchParams();

      var userData = this._authService.getUserData() ;



        if(userData !== undefined && userData != null && this._authService.getUserData().iBreezeUserID !== undefined && this._authService.getUserData().iBreezeUserID !== null ){
      params.set('iBreezeUserID',this._authService.getUserData().iBreezeUserID);
    }else{
      params.set('iBreezeUserID','');
    }
    if(userData !== undefined && userData != null && this._authService.getUserData().breezeSessionString !== undefined && this._authService.getUserData().iBreezeUserID !== null){
      params.set('breezeSessionString',this._authService.getUserData().breezeSessionString);
    }else{
      params.set('breezeSessionString',this._authService.getBreezeSessionString());
    }
       return this._http.get('/api/breezeAuthentication/isUserSessionAlive', {
      headers: this._authService.getAuthorizationHeaders(),
      search: params
    })
      .map((res: Response) => res.json())
      ;
   }

  enrolUser(iBreezeUserID: string,iModuleID:string , breezeSessionString:string, vReferType:string,inStore:string,iSite:string ):Observable<EnrolResponse>{

      let params: URLSearchParams = new URLSearchParams();
        if(this._authService.getUserData().iBreezeUserID !== undefined){
      params.set('iBreezeUserID',iBreezeUserID);
    }else{
      params.set('iBreezeUserID','');
    }
    if(breezeSessionString !== undefined){
      params.set('breezeSessionString',breezeSessionString);
    }else{
      params.set('breezeSessionString','');
    }
      if (iModuleID !== undefined) {
      params.set('iModuleID', iModuleID);
    } else {
      params.set('iModuleID', '');
    }
    if (vReferType !== undefined) {
      params.set('vReferType', vReferType);
    } else {
      params.set('vReferType', '');
    }
    if (inStore !== undefined) {
      params.set('inStore', inStore);
    } else {
      params.set('inStore', '');
    }
    if (iSite !== undefined) {
      params.set('iSite', iSite);
    } else {
      params.set('iSite', '');
    }
       return this._http.get('/api/modules/enrolToModule', {
      headers: this._authService.getAuthorizationHeaders(),
      search: params
    })
      .map((res: Response) => res.json())
      ;
   }

}



// WEBPACK FOOTER //
// ./src/app/enrol-to-module/enrol-to-module.service.ts